import React, { useEffect, useRef, memo } from 'react';

import {
  SnackbarProvider,
  useSnackbar,
  Snackbar,
  Snack,
  SnackCloseButton,
  SnackButton,
} from 'fronton-react';
import { SNACKBARS_DICTIONARY, TSnackbarDictionaryKeys } from 'pages/common/components/Snackbar';
import { SnackbarProps } from 'fronton-react/snackbar/types';
import { SEND_SUCCESS_SNACK, SEND_ERROR_SNACK, SNACKBAR_TIMEOUT } from './consts';

export const BasketLogicSnackbar: React.FC = () => (
  <SnackbarProvider>
    <SnackbarComponent />
  </SnackbarProvider>
);

const SnackbarComponent = memo(
  ({
    horizontalPosition = 'center',
    verticalPosition = 'top',
  }: {
    horizontalPosition?: SnackbarProps['horizontalPosition'];
    verticalPosition?: SnackbarProps['verticalPosition'];
  }) => {
    const { state, addSnack, removeSnack } = useSnackbar();
    const eventHandler = useRef<((e: CustomEvent) => void) | null>(null);
    const handler = (e: CustomEvent) => {
      if (e.type === SEND_SUCCESS_SNACK) {
        setTimeout(() => {
          addSnack(SNACKBARS_DICTIONARY[TSnackbarDictionaryKeys.SUCCESSFULY_ADD_TO_CART]);
        }, SNACKBAR_TIMEOUT);
      } else {
        setTimeout(() => {
          addSnack(SNACKBARS_DICTIONARY[TSnackbarDictionaryKeys.ERROR_ADD_TO_CART]);
        }, SNACKBAR_TIMEOUT);
      }
    };

    useEffect(() => {
      eventHandler.current = e => handler(e);

      document.body.addEventListener(SEND_SUCCESS_SNACK, e =>
        eventHandler.current ? eventHandler.current(e as CustomEvent) : null
      );
      document.body.addEventListener(SEND_ERROR_SNACK, e =>
        eventHandler.current ? eventHandler.current(e as CustomEvent) : null
      );

      return () => {
        document.body.removeEventListener(SEND_SUCCESS_SNACK, e =>
          eventHandler.current ? eventHandler.current(e as CustomEvent) : null
        );
        document.body.removeEventListener(SEND_ERROR_SNACK, e =>
          eventHandler.current ? eventHandler.current(e as CustomEvent) : null
        );
      };
    });

    return (
      <>
        <Snackbar horizontalPosition={horizontalPosition} verticalPosition={verticalPosition}>
          {state.map(({ id, title, content, type, button, closeButton, time, timeout = 3000, wide }) => (
            <Snack
              key={id}
              id={id}
              header={title}
              paragraph={content}
              variant={type}
              wideButton={wide}
              autoHideTimer={time ? timeout : undefined}
              closeButton={closeButton ? <SnackCloseButton onClick={() => removeSnack(id)} /> : undefined}>
              {button && <SnackButton onClick={() => removeSnack(id)}>Закрыть</SnackButton>}
            </Snack>
          ))}
        </Snackbar>
      </>
    );
  }
);
